import '@medical/styles/css'

// slide doctor_toppage
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
// ie9 & ie11 support
import 'react-app-polyfill/ie9'
import '@medical/libs/I18n/i18n'
import 'moment/locale/ja'
import 'antd/dist/reset.css'

import * as Sentry from '@sentry/browser'
import moment from 'moment-timezone'
/* ------------------- Application SASS & CSS ------------------- */
import React from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import * as serviceWorker from './serviceWorker'

import ErrorBoundary from '@medical/components/ErrorBoundary'

moment.locale(process.env.REACT_APP_LOCALE)
moment.tz.setDefault('Asia/Tokyo')
// React App error handling logging
// if (!process.env.REACT_APP_LOCAL_DEVELOPMENT) {
//   Sentry.init({
//     dsn: process.env.REACT_APP_SENTRY_KEY,
//   })
// }

// React 18 root. StrictMode is intentionally NOT enabled: the local
// primereact fork (src/fork/primereact) relies on findDOMNode and legacy
// lifecycles, which StrictMode double-invokes/deprecates.
const root = createRoot(document.getElementById('root'))
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
